import { render, staticRenderFns } from "./TaggerDataLayer.vue?vue&type=template&id=a64ebace&"
import script from "./TaggerDataLayer.vue?vue&type=script&lang=js&"
export * from "./TaggerDataLayer.vue?vue&type=script&lang=js&"
import style0 from "./TaggerDataLayer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardText,VCol,VRow})
